import React, { useState, useEffect } from 'react';
import axios, { AxiosResponse, AxiosRequestConfig } from "axios"
import { MetaResponse } from './models/MetaResponse';
import { AuthResponse } from './models/AuthResponse';
import { AuthData } from './models/AuthData';
import './ui/styles/App.css'
import background from './ui/spinsci_loading.gif';
import failBackground from './ui/failed.png';

function App() {
  const [authText, setAuthText] = useState('Authenticating');
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [backgroundImg, setBackgroundImg] = useState(background);
  const [ctiUrl, setCtiUrl] = useState("");
  const [epicRedirectUrl, setEpicRedirectUrl] = useState("");
  const [epicClientId, setEpicClientId] = useState("");

  useEffect(() => {

    console.debug("[Init] => web application has been initiated");

    fetchSettings()
    .then((settings) => {
      setCtiUrl(settings.cti);
      setEpicRedirectUrl(settings.epic.redirect_uri);
      setEpicClientId(settings.epic.client_id);
      console.debug("[SNAP] => Successfully built snap url", ctiUrl);
    })
    .catch((error) => {
      console.error("[FAILED SETTINGS RESPONSE] => Failed to retieve settings response", error)
      setAuthText('Authentication Failed');
      setIsAuthenticated(false);
      setBackgroundImg(failBackground);
    })

  },[])

    useEffect(()=>{

      let authorize: string = "";
      let token: string = "";
      let code: string | null = "";

      let auth: AuthData = {
        access_token: "",
        token_type: "",
        expires_in: -1,
        scope: "",
        "%USEREMAIL%": "",
        "__epic.dstu2.patient": "",
        encounter: "",
        location: "",
        loginDepartment: "",
        need_patient_banner: "",
        patient: "",
        smart_style_url: "",
      }

      if( window.location.search.search(/\?iss.*&launch|\?launch.*&iss/g) > -1){

        const iss = new URL(window.location.href).searchParams.get("iss");
        const launch = new URL(window.location.href).searchParams.get("launch");

        console.debug("[SMART-FHIR] => Received iss and launch URLs");

        if(iss && launch){

          (async () => {

            const requestConfig: AxiosRequestConfig = {
              method: 'get',
              url: `${decodeURIComponent(iss)}/metadata`,
              headers: {
                "Accept": "application/fhir+json"
              }
            }

            try{
              const {data: metaResponse} = await axios<any, MetaResponse>(requestConfig);
              const params = metaResponse.rest[0].security.extension[0].extension;
              const authIndex = params.findIndex((elem: { url: string; }) => elem.url === 'authorize');
              const tokenIndex = params.findIndex((elem: { url: string;}) => elem.url === 'token');
              authorize = params[authIndex].valueUri;
              token = params[tokenIndex].valueUri;

              console.debug("[SMART-FHIR] => Received Meta Response");
            }
            catch (e){
              console.error(e);
              setAuthText('Authentication Failed');
              setIsAuthenticated(false);
              setBackgroundImg(failBackground);
            }

            if(authorize && token)
            {
              const requestConfig: AxiosRequestConfig = {
                method: 'post',
                url: `${authorize}`,
                headers: {
                  "Content-Type": "application/x-www-form-urlencoded"
                },
                data: {
                  "scope": "launch",
                  "response_type": "code",
                  "redirect_uri": decodeURIComponent(epicRedirectUrl),
                  "client_id": epicClientId,
                  "launch": `${launch}`,
                  "aud": `${iss}`
                }
              }

              try{
                const authResponse = await axios<AxiosResponse>(requestConfig);
                console.debug("[SMART-FHIR]", authResponse);
                console.debug("[SMART-FHIR] authRequest", authResponse.request);
                if(!authResponse.request.responseURL.includes("invalid_grant")){
                  code = new URL(`${authResponse.request.responseURL}`).searchParams.get("code");

                  console.debug("[SMART-FHIR] => Received authorized Response");

                }
              }
              catch(e)
              {
                console.error(e);
                setAuthText('Authentication Failed');
                setIsAuthenticated(false);
                setBackgroundImg(failBackground);
              }

              if(code)
              {
                const requestConfig: AxiosRequestConfig = {
                  method: 'post',
                  url: `${token}`,
                  headers:{
                    "Content-Type": "application/x-www-form-urlencoded"
                  },
                  data:{
                    "grant_type": "authorization_code",
                    "code": `${code}`,
                    "redirect_uri": decodeURIComponent(epicRedirectUrl),
                    "client_id": epicClientId
                  }
                }

                try{

                  const { data: tokenResponse} = await axios<any, AuthResponse>(requestConfig);
                  
                  if(tokenResponse.hasOwnProperty("access_token") && tokenResponse.access_token != null)
                  {

                    console.debug("[SMART-FHIR] => Received Token Response");
                    console.debug("[SMART-FHIR] => Authentication completed, loading Agenta Snap...");

                    setAuthText('Authentication Successful');
                    setIsAuthenticated(true);



                  }
                  else {
                    console.error(tokenResponse);
                    setAuthText('Authentication Failed');
                    setIsAuthenticated(false);
                    setBackgroundImg(failBackground);
                  }
                }
                catch(e)
                {
                  console.error(e);
                  setAuthText('Authentication Failed');
                  setIsAuthenticated(false);
                  setBackgroundImg(failBackground);
                }
              }
            }

          })();

        }
      }

    },[epicRedirectUrl, epicClientId])


  return (
    <div className="App">
      <div className="center-container">
      {!isAuthenticated ? (
          <div className="container">
            <img src={backgroundImg} alt="Background Image" />
            <p className='authStatus'>{authText}</p>
          </div>
        ) : null}

        {isAuthenticated && (
          <div className="iframe-container">
          <iframe
            title="cti-embedded"
            allow="microphone; notifications"
            sandbox="allow-same-origin allow-popups allow-scripts allow-forms"
            src={ctiUrl}
          ></iframe> 
        </div>
        )}
    </div>
      
    </div>
  );
}

const fetchSettings = async () => {

  try {
    const settingsResponse : Response = await fetch(window.location.origin + process.env.PUBLIC_URL + "/config.json");
    const settings = await settingsResponse.json();
    return settings;
  }
  catch(error) {
    console.error("[FAILED RESPONSE] => Failed to retrieve settings response", error)

  }
}



export default App;
